const DB_NAME = 'protocol'
const STORAGE_NAME = 'protocols'
const DB_VERSION = 3
let DB
export default {
  async getDb () {
    return new Promise((resolve, reject) => {
      if (DB) {
        return resolve(DB)
      }
      const request = window.indexedDB.open(DB_NAME, DB_VERSION)
      request.onerror = e => {
        console.log('Error opening db', e)
        // eslint-disable-next-line prefer-promise-reject-errors
        reject('Error')
      }
      request.onsuccess = e => {
        DB = e.target.result
        resolve(DB)
      }
      request.onupgradeneeded = e => {
        console.log(e)
        console.log(e.oldVersion)
        let db = e.target.result
        if (e.oldVersion < 1) {
          db.createObjectStore(STORAGE_NAME, {autoIncrement: true, keyPath: 'id'})
          request.transaction.objectStore(STORAGE_NAME).createIndex('api_id_idx', 'api_id', {unique: false})
        } else {
          request.transaction.objectStore(STORAGE_NAME).createIndex('api_id_idx', 'api_id', {unique: false})
        }
      }
    })
  },
  async deleteProtocol (protocol) {
    const db = await this.getDb()
    return new Promise(resolve => {
      const trans = db.transaction([STORAGE_NAME], 'readwrite')
      trans.oncomplete = () => {
        resolve()
      }
      const store = trans.objectStore(STORAGE_NAME)
      store.delete(protocol.id)
    })
  },
  async getProtocolWhereApiID (apiId) {
    let db = await this.getDb()
    let trans = db.transaction([STORAGE_NAME], 'readonly')
    let store = trans.objectStore(STORAGE_NAME)
    let apiIdIndex = store.index('api_id_idx')
    let request = apiIdIndex.getAll(apiId)
    return new Promise(resolve => {
      request.onsuccess = function () {
        if (request.result !== undefined) {
          resolve(request.result)
        } else {
          resolve([])
        }
      }
    })
  },
  async getProtocols () {
    let db = await this.getDb()
    return new Promise(resolve => {
      let trans = db.transaction([STORAGE_NAME], 'readonly')
      trans.oncomplete = () => {
        resolve(protocols)
      }
      const store = trans.objectStore(STORAGE_NAME)
      const protocols = []
      store.openCursor().onsuccess = e => {
        const cursor = e.target.result
        if (cursor) {
          protocols.push(cursor.value)
          cursor.continue()
        }
      }
    })
  },
  async getProtocol (id) {
    let db = await this.getDb()
    let trans = db.transaction([STORAGE_NAME], 'readonly')
    let store = trans.objectStore(STORAGE_NAME)
    let objectStoreRequest = await store.get(+id)
    return new Promise(resolve => {
      trans.oncomplete = () => {
        let protocol = objectStoreRequest.result
        resolve(protocol)
      }
    })
  },
  async updateProtocol (protocol) {
    let db = await this.getDb()
    return new Promise(resolve => {
      let trans = db.transaction([STORAGE_NAME], 'readwrite')
      trans.oncomplete = () => {
        let resp = objectStoreRequest.result
        resolve(resp)
      }
      let store = trans.objectStore(STORAGE_NAME)
      let objectStoreRequest = store.put(protocol)
    })
  }
}



// WEBPACK FOOTER //
// ./src/functions/idb.js